import type { ActivityLogicPlugin } from '../../core/types/plugin.base.types';
import type {
  StructuralBreakdownPayload,
  StructuralBreakdownRuntime,
} from '../../core/types/payloads/structural_breakdown.types';
import { validateStructuralBreakdownPayload } from '../../core/schemas/humanitiesBlockSchemas';

export function validateStructuralBreakdownPayloadFromLogic(raw: unknown): StructuralBreakdownPayload {
  return validateStructuralBreakdownPayload(raw);
}

export const structuralBreakdownLogic: ActivityLogicPlugin<'structural_breakdown'> = {
  mode: 'structural_breakdown',
  validatePayload: validateStructuralBreakdownPayloadFromLogic,
  createInitialRuntime(): StructuralBreakdownRuntime {
    return { viewed: false };
  },
};

export function demoStructuralBreakdownPayload(): StructuralBreakdownPayload {
  // Neutro — sin Quijote/Mancha (fuga Literatura vía defaultPayloadForMode).
  return validateStructuralBreakdownPayloadFromLogic({
    title: 'Esquema de estructura',
    typography: 'serif',
    explanation:
      'Cada línea es una unidad de sentido. El badge marca el rol (A/B): lee el texto y usa la etiqueta para comparar partes, no como respuesta suelta.',
    whyItMatters:
      'Sirve para ver cómo se organiza el texto antes de interpretar o escribir sobre él.',
    lines: [
      { text: 'Primera unidad de sentido del texto de ejemplo.', badge: 'A' },
      { text: 'Segunda unidad que continúa o desarrolla la anterior.', badge: 'A' },
      { text: 'Unidad contrastante que cierra o responde.', badge: 'B' },
    ],
  });
}
